import { render } from "./intercomMessages.vue?vue&type=template&id=7a3b5ab3&scoped=true"
import script from "./intercomMessages.vue?vue&type=script&lang=js"
export * from "./intercomMessages.vue?vue&type=script&lang=js"

import "./intercomMessages.vue?vue&type=style&index=0&id=7a3b5ab3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a3b5ab3"]])

export default __exports__